import type { EventEcgCardioExaminationDuration } from '../../../../../../common/enums/eventEcgCardioExaminationDuration';
import type { Gender } from '../../../../../../common/enums/gender';
import type { HolterCardioExaminationDuration } from '../../../../../../common/enums/holterCardioExaminationDuration';
import type { TcohProcedureType } from '../../../../../../common/enums/tcohProcedureType';

interface IIndicatieData {
    algemeenOnderzoek: boolean;
    andersText: string | null;
    atypischeAngina: boolean;
    controleTherapie: boolean;
    decompensatioCordis: boolean;
    duizeling: boolean;
    dyspnoeDeffort: boolean;
    geruststelling: boolean;
    hartfalen: boolean;
    hartkloppingen: boolean;
    hypertensie: boolean;
    kleplijden: boolean;
    ritmeGeleidingsstoornissen: boolean;
    typischeAngina: boolean;
    ventrikelHypertrofie: boolean;
    verdenkingIschemie: boolean;
}

interface IMedicatieData {
    aceRemmer: boolean;
    andersText: string | null;
    antiAritmica: boolean;
    antiHypertensiva: boolean;
    antiStolling: boolean;
    betaBlokker: boolean;
    calciumantagonist: boolean;
    digitalis: boolean;
    diuretica: boolean;
    geenCardialeMedicatie: boolean;
    geenMedicatie: boolean;
    nitraten: boolean;
}

export interface ICustomControlData {
    adviesBijAfwijkendeBeoordeling?: 'Ja' | 'Nee' | null;
    adviesBijAfwijkendeBeoordelingVraag?: string | null;
    bekendeEcgAfwijkingen?: string | null;
    bloeddruk_diastolisch?: string | null;
    bloeddruk_systolisch?: string | null;
    eventEcgCardioExaminationDuration: EventEcgCardioExaminationDuration | null;
    geslachtHolter: Gender.male | Gender.female | null;
    gewicht: number | null;
    hasPacemaker?: 'Ja' | 'Nee';
    holterCardioExaminationDuration: HolterCardioExaminationDuration | null;
    indicatie: IIndicatieData;
    lengte: number | null;
    medicatie: IMedicatieData;
    procedureType: TcohProcedureType | null;
    toelichting?: string | null;
    vraagstelling?: string | null;
}

function sharedInitializeCustomControlData() {
    return {
        aceRemmer: false,
        adviesBijAfwijkendeBeoordeling: null,
        adviesBijAfwijkendeBeoordelingVraag: null,
        algemeenOnderzoek: false,
        andersText: null,
        antiAritmica: false,
        antiHypertensiva: false,
        antiStolling: false,
        betaBlokker: false,
        calciumantagonist: false,
        controleTherapie: false,
        decompensatioCordis: false,
        digitalis: false,
        diuretica: false,
        dyspnoeDeffort: false,
        eventEcgCardioExaminationDuration: null,
        geruststelling: false,
        geslachtHolter: null,
        gewicht: null,
        hartfalen: false,
        hartkloppingen: false,
        hasPacemaker: 'Nee',
        holterCardioExaminationDuration: null,
        hypertensie: false,
        indicatie: {
            algemeenOnderzoek: false,
            andersText: null,
            atypischeAngina: false,
            controleTherapie: false,
            decompensatioCordis: false,
            duizeling: false,
            dyspnoeDeffort: false,
            geruststelling: false,
            hartfalen: false,
            hartkloppingen: false,
            hypertensie: false,
            kleplijden: false,
            ritmeGeleidingsstoornissen: false,
            typischeAngina: false,
            ventrikelHypertrofie: false,
            verdenkingIschemie: false,
        },
        lengte: null,
        medicatie: {
            aceRemmer: false,
            andersText: null,
            antiAritmica: false,
            antiHypertensiva: false,
            antiStolling: false,
            betaBlokker: false,
            calciumantagonist: false,
            digitalis: false,
            diuretica: false,
            geenCardialeMedicatie: false,
            geenMedicatie: false,
            nitraten: false,
        },
        procedureType: null,
    };
}

export function tcohV2RequestInitializeCustomControlData() {
    return {
        ...sharedInitializeCustomControlData(),
        bloeddruk_diastolisch: null,
        bloeddruk_systolisch: null,
        contactgegevens_patient: {
            emailadres: null,
            homePhoneNumber: null,
            mobileNumber: null,
        },
        toelichting: null,
    };
}

export function tcohV2ProcedureInitializeCustomControlData(isDirectProcedureAdded?: boolean) {
    return isDirectProcedureAdded
        ? {
              ...sharedInitializeCustomControlData(),
              bekendeEcgAfwijkingen: null,
              vraagstelling: null,
          }
        : {};
}
